import React from 'react';

const ErrorIndicator = () => {
  return (
    <div>
      <h3>Something wrong, please refresh page...</h3>
    </div>
  );
}

export default ErrorIndicator;
